// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfISOWeekYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfISOWeekYear = convertToFP(fn, 1);
export default lastDayOfISOWeekYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfISOWeekYear/index.js
// module id = 950
// module chunks = 0